import React, { Component } from "react";
import Empty from "../../image/empty.svg"
import axios from "axios";
import TutorDashMenu from "../../part/tutor_dash_menu";
import FooterDashboard from "../../part/footer.dashboard";
import Policy from "../../part/policy";
import DashSearchHeader from "../../part/header.search.dashboard";
import { Link } from "react-router-dom";
import FilterCourse from "../../part/filter_bar_course";
import LoadingError from "../../part/loading_error";


class TutorInterestedStudents extends Component {
    state = {
        menuCoverWidth: this.getInitialMenuCoverWidth(),
        students: [],
        isContactVisible: false,
        filter_type_name: "Type",
        filter_level_name: "Level",
        filter_status_name: "Status",
        loading : false
    }
    getInitialMenuCoverWidth() {
        const windowWidth = window.innerWidth;
        if (windowWidth < 900) {
            return 0;
        } else if (windowWidth >= 900 && windowWidth < 1200) {
            return 60;
        } else {
            return 260;
        }
    }
    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        this.fetchInterestedStudents();

        const storedUser = localStorage.getItem('user');
        if (storedUser) {
            try {
                const user = JSON.parse(storedUser);
                if (user && user.role === 'student') {
                    window.location.href = '/dashboard';
                }
            } catch (error) {
                console.error("Error parsing user data:", error);
                localStorage.removeItem('user');
                localStorage.removeItem('accessToken');
                window.location.href = '/login';
            }
        } else {
            localStorage.removeItem('user');
            localStorage.removeItem('accessToken');
            window.location.href = '/login';
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize = () => {
        const menuCover = document.querySelector('.dashboard .menu_cover');
        if (menuCover) {
            this.setState({ menuCoverWidth: menuCover.offsetWidth });
        }
        this.setState({ windowHeight: window.innerHeight - 60 });
    };

    fetchInterestedStudents = async () => {
        const accessToken = localStorage.getItem("accessToken");
        this.setState({loading:true})
        try {
            const response = await axios.get("https://api.geoinfoacademy.com/api/tutor/interested-courses/", {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            this.setState({ students: response.data , loading: false});
            // const allData = response.data;
            // const chunkSize = 20;

            // // Immediately set the first 100 to make the UI snappy
            // this.setState({ students: allData.slice(0, chunkSize) });

            // // Then, after a tiny delay, load the rest in the background
            // if (allData.length > chunkSize) {
            //     setTimeout(() => {
            //         this.setState({ students: allData });
            //     }, 500);
            // }
            console.log("API Response:", response.data);
        } catch (error) {
            this.setState({loading: false})
            if (error.response && error.response.status === 401) {
                console.warn("401 Unauthorized error detected. Clearing local storage and redirecting.");
                localStorage.removeItem("accessToken");
                localStorage.removeItem("user");
                window.location.href = "/";
            } else {
                console.error("Error fetching data:", error);
            }
        }
    };

    initialfilterbytype = () => {
        // 1. Point to the actual array (the list of interested courses)
        const interestedRecords = this.state.students || [];

        if (this.state.filter_type_name === "Type" || this.state.filter_type_name === "All") {
            return interestedRecords;
        } else {
            // 2. Access the nested course object: item.course.labels
            return interestedRecords.filter((item) => item.course?.labels === this.state.filter_type_name);
        }
    };

    initialfilterbylevel = () => {
        const records = this.initialfilterbytype();

        if (this.state.filter_level_name === "Level" || this.state.filter_level_name === "All") {
            return records;
        } else if (this.state.filter_level_name === "Advance/Professional") {
            return records.filter(
                (item) =>
                    item.course?.tags === "Advance" ||
                    item.course?.tags === "Professional"
            );
        } else if (this.state.filter_level_name === "Beginner to Advance/Professional") {
            return records.filter(
                (item) =>
                    item.course?.tags === "Beginner to Advance" ||
                    item.course?.tags === "Beginner to Professional"
            );
        } else {
            return records.filter((item) => item.course?.tags === this.state.filter_level_name);
        }
    };
    initialfilterbystatus = () => {
        // This receives the filtered list from the previous level
        const records = this.initialfilterbylevel();

        if (this.state.filter_status_name === "Status" || this.state.filter_status_name === "All") {
            return records;
        }

        else if (this.state.filter_status_name === "Online") {
            return records.filter(
                (item) =>
                    item.course?.training_type === "Online Prerecorded" ||
                    item.course?.training_type === "Online Live with Facilitator"
            );
        }

        else if (this.state.filter_status_name === "Physical") {
            return records.filter(
                (item) =>
                    item.course?.training_type === "General Physical Class" ||
                    item.course?.training_type === "Physical Private Class"
            );
        }

        else {
            // Fallback for any other specific status name
            return records.filter(
                (item) => item.course?.training_type === this.state.filter_status_name
            );
        }
    };
    handleFilterChange = (filterType, filterLevel, filterStatus) => {
        this.setState({
            filter_type_name: filterType,
            filter_level_name: filterLevel,
            filter_status_name: filterStatus,
        })
    };


    handleRefresh = () => {
        this.setState({
            filter_type_name: "Type",
            selectedItem: "",
            filter_level_name: "Level",
            selectedItems: "",
            filter_status_name: "Status",
            selectedIteme: ""
        }, () => {
            // Important: Call the reset on the child!
            this.filterRef.handleReset(); // Assuming you add a ref to the FilterCourse component
        })
    }





    handleStudentInfoDelete = async (id) => {
        const accessToken = localStorage.getItem("accessToken");

        try {
            await axios.delete(`https://api.geoinfoacademy.com/api/tutor/interested-courses/${id}/`, {

                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },

            });
            // Update the studentList state to remove the deleted item
            this.fetchInterestedStudent()
        } catch (error) {
            console.error('Error deleting interested course:', error);
            // Handle error (e.g., show an error message)
        }
    };


    handleDownloadSingle = async (id) => {
        const accessToken = localStorage.getItem("accessToken");
        try {
            const response = await axios.get(
                `https://api.geoinfoacademy.com/api/tutor/interested-courses/${id}/download-single/`,
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                    responseType: 'blob', // Important: Indicate that you expect a binary blob
                }
            );

            // Create a blob URL and trigger download
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `interested_course_${id}.xlsx`); // Set desired filename
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url); // Clean up the URL object

        } catch (error) {
            console.error("Error downloading single data:", error);
            // Handle error (e.g., show an error message)
        }
    };

    handleDownloadMultiple = async () => {
        const accessToken = localStorage.getItem("accessToken");
        try {
            const response = await axios.get(
                "https://api.geoinfoacademy.com/api/tutor/interested-courses/download-multiple/",
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                    responseType: 'blob', // Important: Indicate that you expect a binary blob
                }
            );

            // Create a blob URL and trigger download
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'interested_courses_multiple.xlsx'); // Set desired filename
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url); // Clean up the URL object

        } catch (error) {
            console.error("Error downloading multiple data:", error);
            // Handle error (e.g., show an error message)
        }
    };


    render() {
        const { menuCoverWidth, students, loading } = this.state;
        const filteredstudents = this.initialfilterbystatus()
        const sortedStudentList = [...filteredstudents].sort((a, b) => b.id - a.id);
        const studentlist = sortedStudentList.length > 0 ? sortedStudentList.map((info, index) => {
            return (
                <tr key={info.id}>
                    <td className="sn">{index + 1}</td>
                    <td>{info.student.first_name}</td>
                    <td>{info.student.last_name}</td>
                    <td>{info.student.email}</td>
                    <td>{info.student.phone_number}</td>
                    <td>{info.student.address}</td>
                    <td>{info.student.interested_date}</td>
                    <td>{info.course.title}</td>
                    <td>{info.course.tags}</td>
                    <td>{info.course.labels}</td>
                    <td>{info.course.price}</td>
                    <td className="delete" ><button onClick={() => this.handleStudentInfoDelete(info.id)} className="delete-button" style={{ backgroundColor: "red", color: "white", width: "150px", border: "red", borderRadius: "30px" }} > Delete </button></td>
                    <td className="delete" ><button onClick={() => this.handleDownloadSingle(info.id)} className="delete-button" style={{ backgroundColor: "rgb(0,0,0,0)", color: "rgba(0, 0, 0, 0.8)", width: "150px", border: "1px solid rgb(20,107,217)", borderRadius: "30px" }} >Download</button></td>
                </tr>

            )
        }) : (
            <tr className="course_list_empty">
                <td>Loading ......</td>
            </tr>
        )

        return (
            <div className="dashboard">
                <DashSearchHeader onResize={this.handleResize} />
                <TutorDashMenu />
                <div className="dash_body" style={{ width: `calc(100% - ${menuCoverWidth}px - 10px)`, overflow: 'hidden' }}>
                    <div className="course_head" style={{ padding: "30px 0px" }} >
                        <h2> Interested Student <button onClick={this.handleDownloadMultiple}>Download All</button></h2>
                        <FilterCourse
                            filterType={this.state.filter_type_name} // Pass current values as props
                            filterLevel={this.state.filter_level_name}
                            filterStatus={this.state.filter_status_name}
                            onFilterChange={this.handleFilterChange}
                            ref={(el) => this.filterRef = el}
                        />
                    </div>

                    <div className="course_body">
                        <div className="course_body_cover">

                            {students.length > 1 ?
                                < div className="table">
                                    <table className="librarytable">
                                        <thead>
                                            <tr>
                                                <th className="sn">S/N</th>
                                                <th>First Name</th>
                                                <th>Last Name</th>
                                                <th>Email</th>
                                                <th>Phone Number </th>
                                                <th>Address </th>
                                                <th>Date</th>
                                                <th className="course"> Course Title </th>
                                                <th>Course Tags</th>
                                                <th>Course Labels</th>
                                                <th>Price</th>
                                                <th className="delete">Delete</th>
                                                <th className="delete">Download</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {studentlist}
                                        </tbody>
                                    </table>
                                </div> :
                                <div className="course_list_empty">
                                    <img src={Empty} alt="not avaialable" /><br />
                                    <h5>No available course <br />with that specification.</h5>
                                    <button onClick={this.handleRefresh}>Reset Filter</button>
                                </div>
                            }
                        </div>
                    </div>

                    <FooterDashboard />
                    <Policy />
                </div>
                {loading ? <LoadingError /> : null}
            </div>
        )
    }
}

export default TutorInterestedStudents